import React from 'react';
import { useTranslation } from 'react-i18next';
import { IBreadcrumbItem } from '../../../../models/breadcrumb';
import { Breadcrumb } from 'antd';
import { Link, useLocation } from 'react-router-dom';

interface IndTemplateBreadcrumbProps {
    separator: string;
    indicatorId: number; // Add the indicatorId prop
}

const IndTemplateBreadcrumb: React.FC<IndTemplateBreadcrumbProps> = ({ separator, indicatorId }) => {
    const { t } = useTranslation();
    const location = useLocation();
    const getBreadcrumbName = () => {
        if (location.pathname.startsWith('/indicator')) {
            const retrievedArray = JSON.parse(localStorage.getItem('indicatorMenu') || '[]');
            const indicator = retrievedArray?.find((ind: any) => ind.id === indicatorId);

            if (indicator) {
                return indicator.name;
            }
            else {
                return t('temp.name.to.be.displayed.here');
            }
        }
        else if(location.pathname.startsWith('/reports')){
            const retrievedArray = JSON.parse(localStorage.getItem('reportMenu') || '[]');

            const reports = retrievedArray?.find((ind: any) => ind.id === indicatorId);

            if (reports) {
                return reports.name;
            }
            else {
                return t('temp.name.to.be.displayed.here');
            }
        }
    }

    const breadcrumbItems: Array<IBreadcrumbItem> = [
        { title: t('home'), path: '/home' },
        // Use the indicator name as the second breadcrumb item
        { title: getBreadcrumbName() },
    ];

    return (
        <>
            <h4>{localStorage.getItem('ministryName')}</h4>
            <Breadcrumb style={{ margin: '0 0' }} separator={separator}>
                {breadcrumbItems.map((item, index) => (
                    <Breadcrumb.Item key={index}>
                        {item?.path ? (
                            <Link to={item.path}>{item.title}</Link>
                        ) : (
                            <>{item.title}</>
                        )}
                    </Breadcrumb.Item>
                ))}
            </Breadcrumb>

        </>
    );
};

export default IndTemplateBreadcrumb;
